import { useState } from "react";
import { LiquidityPoolComponent  } from '../components/LiquidityPoolComponent';

export const LiquidityPool = (props) => {
    return <LiquidityPoolComponent { ...props } />
}